// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import { useState } from 'react';

const UPLOAD_STATE = {
  IDLE: 'idle',
  PROCESSING: 'processing',
  COMPLETE: 'complete',
};

export default function useBulkCreateState() {
  const [uploadState, setUploadState] = useState(UPLOAD_STATE.IDLE);
  const [selectedFile, setSelectedFile] = useState(null);
  const [pipelineCount, setPipelineCount] = useState(0);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [results, setResults] = useState({
    createdPipelines: [],
    failedPipelines: [],
    succeeded: 0,
    failed: 0,
  });

  const reset = () => {
    setUploadState(UPLOAD_STATE.IDLE);
    setSelectedFile(null);
    setPipelineCount(0);
    setHasError(false);
    setErrorMessage('');
    setResults({
      createdPipelines: [],
      failedPipelines: [],
      succeeded: 0,
      failed: 0,
    });
  };

  return {
    uploadState,
    setUploadState,
    selectedFile,
    setSelectedFile,
    pipelineCount,
    setPipelineCount,
    hasError,
    setHasError,
    errorMessage,
    setErrorMessage,
    results,
    setResults,
    reset,
    UPLOAD_STATE,
  };
}
